<template>
  <a
    :href="`mailto:${row[col.field]}`">
    {{row[col.field]}}
  </a>
</template>

<script>
export default {
  name: 'TemplateEmail',
  props: {
    row: { type: Object, required: true },
    col: { type: Object, required: true },
    template: { type: Object, required: true }
  }
}
</script>
